(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stepz-mechanism"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stepz-mechanism')) {
    customElements.define('stepz-mechanism', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('.spz-mechanism__toggle');
        this.manuallyPaused = false;
        this.inView = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.abort.signal };
        const link = this.querySelector('.spz-mechanism__cta');
        if (link) link.addEventListener('click', event => {
          if (link.getAttribute('href') !== '#top-offer') return;
          event.preventDefault();
          const target = document.getElementById('top-offer');
          const behavior = this.motion.matches ? 'auto' : 'smooth';
          if (target) target.scrollIntoView({ behavior, block: 'start' });
          else window.scrollTo({ top: 0, behavior });
        }, options);
        if (!this.video || !this.toggle) return;
        this.video.controls = false;
        this.video.muted = true;
        this.toggle.hidden = false;
        const sync = () => {
          this.toggleAttribute('data-playing', !this.video.paused);
          this.toggle.setAttribute('aria-label', this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        };
        this.video.addEventListener('play', sync, options);
        this.video.addEventListener('pause', sync, options);
        this.toggle.addEventListener('click', () => {
          if (this.video.paused) {
            this.manuallyPaused = false;
            this.video.play().catch(sync);
          } else {
            this.manuallyPaused = true;
            this.video.pause();
          }
        }, options);
        const resume = () => {
          if (this.inView && !this.manuallyPaused && !this.motion.matches && !document.hidden) this.video.play().catch(sync);
          else this.video.pause();
        };
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          resume();
        }, { threshold: .2 });
        this.observer.observe(this.video);
        document.addEventListener('visibilitychange', resume, options);
        this.motion.addEventListener('change', resume, options);
        sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.video?.pause();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stepz-video-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stepz-video-story')) {
    customElements.define('stepz-video-story', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('.stepz-video-story__toggle');
        if (!this.video || !this.toggle) return;
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused ??= false;
        this.wantsPlayback = !this.motion.matches && !this.userPaused;
        this.inView = false;
        this.video.muted = true;
        this.video.controls = false;
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', () => {
          this.wantsPlayback = this.video.paused;
          this.userPaused = !this.wantsPlayback;
          this.syncPlayback();
        }, options);
        this.video.addEventListener('play', () => this.syncButton(), options);
        this.video.addEventListener('pause', () => this.syncButton(), options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.motion.addEventListener('change', () => {
          this.wantsPlayback = !this.motion.matches && !this.userPaused;
          this.syncPlayback();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPlayback();
        }, { threshold: 0.15 });
        this.observer.observe(this);
        this.syncButton();
      }
      syncPlayback() {
        if (this.inView && this.wantsPlayback && !document.hidden) {
          this.video.play().catch(() => this.syncButton());
        } else {
          this.video.pause();
        }
      }
      syncButton() {
        const playing = !this.video.paused;
        this.toggleAttribute('data-playing', playing);
        this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stepz-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stepz-video-testimonials')) {
    customElements.define('stepz-video-testimonials', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.track = this.querySelector('.stepz-testimonials__track');
        this.cards = Array.from(this.querySelectorAll('.stepz-testimonials__card'));
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.position = this.querySelector('[data-position]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.controller.signal };
        this.addEventListener('click', event => {
          const play = event.target.closest('[data-play]');
          const close = event.target.closest('[data-close]');
          if (play) this.openVideo(play.closest('.stepz-testimonials__card'));
          if (close) this.closeVideo(close.closest('.stepz-testimonials__card'), true);
          if (event.target.closest('[data-previous]')) this.move(-1);
          if (event.target.closest('[data-next]')) this.move(1);
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this.activeCard) this.closeVideo(this.activeCard, true);
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.track.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
        document.addEventListener('stepz:testimonial:play', event => {
          if (event.detail.owner !== this && this.activeCard) this.closeVideo(this.activeCard);
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
          if (card) this.track.scrollTo({ left: this.cardOffset(card), behavior: 'auto' });
        }, options);
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(this)) this.cleanup();
        }, options);
        this.cards.forEach(card => {
          const video = card.querySelector('video');
          video.addEventListener('error', () => { if (video.error) this.handleVideoError(card); }, options);
          video.addEventListener('play', () => {
            if (this.activeCard && this.activeCard !== card) this.closeVideo(this.activeCard);
            this.activeCard = card;
            document.dispatchEvent(new CustomEvent('stepz:testimonial:play', { detail: { owner: this } }));
          }, options);
        });
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.track);
        this.visibilityObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) entry.target.querySelector('video')?.pause();
          });
        }, { threshold: 0 });
        this.cards.forEach(card => this.visibilityObserver.observe(card));
        this.updateNavigation();
      }
      cardOffset(card) {
        const padding = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        return card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft - padding;
      }
      move(direction) {
        const card = this.cards[0];
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.motion.matches ? 'auto' : 'smooth' });
      }
      updateNavigation() {
        const left = this.track.scrollLeft;
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        if (this.previous) this.previous.disabled = left <= 2;
        if (this.next) this.next.disabled = left >= maximum - 2;
        if (this.position) {
          let nearest = 0;
          let distance = Infinity;
          this.cards.forEach((card, index) => {
            const candidate = Math.abs(this.cardOffset(card) - left);
            if (candidate < distance) { nearest = index; distance = candidate; }
          });
          this.position.textContent = maximum > 2 && left >= maximum - 2 ? this.cards.length : nearest + 1;
        }
      }
      sourcesFor(video) {
        let sources;
        try { sources = JSON.parse(video.dataset.sources || '[]') || []; } catch { sources = []; }
        const mp4 = sources.filter(source => source.format === 'mp4' || source.mime_type === 'video/mp4');
        const resolution = source => Number(source.height) || Infinity;
        const small = mp4.filter(source => resolution(source) <= 720).sort((a, b) => resolution(b) - resolution(a));
        const fallback = small[0] || mp4.sort((a, b) => resolution(a) - resolution(b))[0];
        const hls = sources.find(source => source.format === 'm3u8' || /mpegurl/i.test(source.mime_type || ''));
        return { preferred: hls && video.canPlayType('application/vnd.apple.mpegurl') ? hls : fallback, fallback };
      }
      openVideo(card) {
        if (this.activeCard) this.closeVideo(this.activeCard);
        const video = card.querySelector('video');
        const { preferred, fallback } = this.sourcesFor(video);
        const error = card.querySelector('.stepz-testimonials__error');
        error.hidden = true;
        if (!preferred?.url) { this.showError(card); return; }
        document.dispatchEvent(new CustomEvent('stepz:testimonial:play', { detail: { owner: this } }));
        this.activeCard = card;
        card.querySelector('[data-play]').hidden = true;
        card.querySelector('[data-close]').hidden = false;
        video.hidden = false;
        video.dataset.fallback = fallback?.url || '';
        video.dataset.fallbackTried = preferred.url === fallback?.url ? 'true' : 'false';
        video.muted = false;
        this.playSource(card, preferred.url);
        video.focus({ preventScroll: true });
      }
      playSource(card, url) {
        const video = card.querySelector('video');
        const attempt = Number(video.dataset.attempt || 0) + 1;
        video.dataset.attempt = String(attempt);
        video.src = url;
        video.play().catch(error => {
          if (this.activeCard !== card || Number(video.dataset.attempt) !== attempt || error.name === 'AbortError') return;
          if (error.name === 'NotAllowedError') { video.focus({ preventScroll: true }); return; }
          this.handleVideoError(card);
        });
      }
      handleVideoError(card) {
        if (this.activeCard !== card) return;
        const video = card.querySelector('video');
        if (video.dataset.fallback && video.dataset.fallbackTried !== 'true') {
          video.dataset.fallbackTried = 'true';
          this.playSource(card, video.dataset.fallback);
          return;
        }
        this.showError(card);
      }
      showError(card) {
        this.closeVideo(card, true);
        const error = card.querySelector('.stepz-testimonials__error');
        error.textContent = this.dataset.errorLabel;
        error.hidden = false;
      }
      closeVideo(card, focus = false) {
        const video = card.querySelector('video');
        if (this.activeCard === card) this.activeCard = null;
        video.dataset.attempt = String(Number(video.dataset.attempt || 0) + 1);
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.hidden = true;
        card.querySelector('[data-close]').hidden = true;
        const play = card.querySelector('[data-play]');
        play.hidden = false;
        if (focus) play.focus({ preventScroll: true });
      }
      cleanup() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        if (this.activeCard) this.closeVideo(this.activeCard);
      }
      disconnectedCallback() { this.cleanup(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
